module.exports = __webpack_public_path__ + "static/media/group-13.878bde75.svg";